/* eslint-disable @typescript-eslint/default-param-last */
import { Reducer } from 'redux';
import { IIntegration, IIntegrationApp } from 'types';
import { Integrations } from './types';

const initialState: IIntegrationApp[] | null = null;

export const integrationAppsReducer: Reducer<IIntegrationApp[] | null> = (state = initialState, action) => {
  switch (action.type) {
    case Integrations.GET_INTEGRATION_APPS_SUCCESS: {
      return action.payload;
    }
    default: {
      return state;
    }
  }
};

const siteIntegrationsInitialState: Record<string, IIntegration[]> | null = null;

/** Live POS integrations per site, keyed by siteId (read-only system settings view). */
export const siteIntegrationsReducer: Reducer<Record<string, IIntegration[]> | null> = (state = siteIntegrationsInitialState, action) => {
  switch (action.type) {
    case Integrations.LIST_SITE_INTEGRATIONS_SUCCESS: {
      const { siteId, integrations } = action.payload;

      return {
        ...state,
        [siteId]: integrations,
      };
    }
    default: {
      return state;
    }
  }
};
